import { startOfYear as l, getMonth as a, getYear as n, format as M, addMonths as d, isSameMonth as y, isBefore as g, addYears as u } from "date-fns";
import { useMemo as c } from "react";
const Y = "MM", O = "yyyy", T = "yyyy", _ = "MMMM", b = (o, s, t) => {
  const r = [];
  let e = l(o);
  if (s && t)
    for (let i = 0; i < 12; ++i) {
      const f = a(s) > a(e), h = a(t) < a(e), A = n(s) >= n(e), R = n(t) <= n(e);
      r.push({
        isDisabled: f && A || h && R,
        isSelected: a(o) === i,
        value: M(e, Y),
        label: M(e, _)
      }), e = d(e, 1);
    }
  return r;
}, p = (o, s, t) => {
  const r = [];
  let e = l(s || /* @__PURE__ */ new Date());
  for (; t && (y(e, t) || g(e, t)); )
    r.push({
      value: M(e, O),
      label: M(e, T),
      isSelected: n(o) === n(e)
    }), e = u(e, 1);
  return r;
}, E = (o, s, t) => c(() => b(o, t, s), [o, t, s]).filter(
  (r) => !r.isDisabled
), F = (o, s, t) => c(() => p(o, t, s), [t, s, o]).filter(
  (r) => !r.isDisabled
);
export {
  _ as LABEL_MONTH_FORMAT,
  T as LABEL_YEAR_FORMAT,
  Y as MONTH_FORMAT,
  O as YEAR_FORMAT,
  b as monthRange,
  E as useMonthsRange,
  F as useYearsRange,
  p as yearRange
};
//# sourceMappingURL=index.es5862.js.map
